"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _default = (0, _styledComponents.default)(_UIIcon.default).attrs(function () {
  return {
    name: 'sprocket',
    size: 24
  };
}).withConfig({
  displayName: "StyledSprocketIcon",
  componentId: "sc-1g4ha3i-0"
})(["vertical-align:sub;"]);

exports.default = _default;
module.exports = exports.default;